// eslint-disable-next-line import/prefer-default-export
export const interpolateOptionsWithVehicleCount = (options, count) => {
  return options.map(option => ({
    ...option,
    label: option.label.replaceAll('{{vehicleCount}}', `(${count})`),
  }));
};
